import { search } from './searchService';
import { get, getById, put, post } from './apiService';
import type { CallPhoneNumber } from '../types/callPhoneNumber';
import type { SearchParams } from '../types/search';

export async function getCallPhoneNumberById(id: string, queryParams?: string): Promise<CallPhoneNumber> {
  return getById<CallPhoneNumber>('/call-phone', id, queryParams);
}

export async function updateCallPhoneNumber(id: string, data: CallPhoneNumber): Promise<CallPhoneNumber> {
  return put<CallPhoneNumber>(`/call-phone/${id}`, data);
}

export async function searchCallPhoneNumbers(
  filter: Record<string, string> = {},
  params: SearchParams = {},
): Promise<CallPhoneNumber[]> {
  return search<CallPhoneNumber>('/call-phone/search', filter, params);
}

export interface SyncTwilioResult {
  totalProcessed: number;
  new: number;
  changed: number;
  deleted: number;
}

export async function syncTwilioActiveNumbers(): Promise<SyncTwilioResult> {
  return get<SyncTwilioResult>('/call-phone/twilio/active?trunk=twilio-retell');
}

export async function syncRetellActiveNumbers(): Promise<SyncTwilioResult> {
  return get<SyncTwilioResult>('/call-phone/retell/active');
}

export async function importPhoneToRetell(phoneNumber: string): Promise<void> {
  return post<void>('/call-phone/retell/import', { phoneNumber });
}

export async function deletePhoneFromRetell(phoneNumber: string): Promise<void> {
  return post<void>('/call-phone/retell/delete', { phoneNumber });
}
